// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".idm-btn.primary.generate-data-btn {\n  margin-top: 12px;\n  margin-left: auto;\n}\n.editor-text {\n  display: flex;\n  flex-direction: column;\n  margin-top: 14px;\n}\n.editor-text .editor-text-title {\n  margin-bottom: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--dark-500);\n}\n.editor-text .editor-text-title span {\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
